const userrole = {
  getlist: 'userrole/getlist',
  add: 'userrole/add',
  update: 'userrole/update',
  remove: 'userrole/remove',
  get: 'userrole/get',
  getall: 'userrole/getall',
  assign: 'userrole/assign',
}
export default userrole
